module.exports = __webpack_public_path__ + "img/hongbao_bg.9ddadbeb.png";